var exports = {
  "N": "MentionTooltipContent.module__card___MXNXQk",
};

module.exports = exports;
